import { DoujinDetail, DoujinSource } from '@/model/doujin';
import { scraping, scrapingFile } from '@/repository/centralized';
import { getImage } from '@/repository/comic';
import { scrapingViaAPI, getImage as getDoujinImage } from '@/repository/doujin';
import { getConfig } from '@/repository/config';
import { fetchImage, mangaDex } from '@/repository/third-party';
import { HentaiDetail, HentaiStatus } from '@/model/hentai';
import { JAV } from '@/model/jav';
import { Scraping, ScrapingQuery } from '@/model/centralized';
import { Map } from '@/model/universal';
import { capitalize } from './universal';

const clawBracketsRegex = /\[(.*?)\]/g;
const bracketsRegex = /\((.*?)\)/g;
const userAgent =
	'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/147.0.0.0 Safari/537.36';

export async function scrapingComic(
	url: string,
	callback: (file: File, index: number, total: number, referer: string, imageURL: string) => void,
	skipURLs?: string[]
) {
	url = url.trim();
	const result = await extractImageURL(url);
	result.imageURLs = result.imageURLs.map((url) => url.trim());
	if (result.imageURLs.length === 0) {
		throw Error('image is not found');
	}

	await Promise.all(
		result.imageURLs.map(async (imageURL, index) => {
			if (skipURLs && skipURLs.includes(imageURL)) {
				return;
			}

			const image = result.useCookie
				? await getDoujinImage(imageURL)
				: !result.referer
					? await fetchImage(imageURL)
					: !result.host
						? await getImage(imageURL, result.referer, result.host)
						: await scrapingFile({ fileURL: imageURL, fetchFromURL: url });
			if (image.data) {
				callback(
					new File([image.data], imageURL, { type: image.mimeType }),
					index,
					result.imageURLs.length,
					result.referer,
					imageURL
				);
			}
		})
	);
}

async function extractImageURL(
	url: string
): Promise<{ imageURLs: string[]; referer: string; host?: string; useCookie?: boolean }> {
	const referer = new URL(url).origin;
	const imageURLs: string[] = [];
	let contentSelector = '';
	const additionalReq: Partial<Scraping> = {};
	// let isCrossSiteFetching = false;
	switch (referer) {
		case 'https://oredoujin.com':
			contentSelector = 'div.bixbox > div > div.epcontent > center > p';
			break;

		case 'https://manhwa18.cc':
			contentSelector = '.read-content';
			break;

		case 'https://watashitachimanga.com':
			contentSelector = '#reader-container';
			additionalReq.waitTime = 3000;
			break;

		case 'https://www.kingsmanga.net':
			contentSelector = '.post-content';
			break;

		case 'https://god-doujin.com':
		case 'https://ped-doujin.com':
			contentSelector = '#readerarea > p';
			break;

		case 'https://romance-manga.com':
			contentSelector = '.reader-area > p';
			break;

		case 'https://www.rh2plusmanga.com':
			contentSelector = '.reading-content > div:nth-child(3) > code';
			break;

		case 'https://toomtam-manga.com':
		case 'https://speed-manga.com':
		case 'https://ecchi-doujin.com':
		case 'https://www.go-manga.com':
		case 'https://toonhunter.com':
		case 'https://www.tanuki-manga.com':
		case 'https://manga168.com':
		case 'https://manga168.net':
		case 'https://doujin89.com':
		case 'https://rawkuma.com':
		case 'https://moon-toon.com':
			contentSelector = '#readerarea';
			// isCrossSiteFetching = ['https://manga168.com'].includes(referer);
			break;

		case 'https://mangadex.org':
			return extractionViaAPI(url, referer);

		default:
			return specialSiteExtraction(url, referer);
	}

	const result = await scraping<{ content: string }>({
		...additionalReq,
		url,
		querys: [
			{
				name: 'content',
				selector: contentSelector,
				target: 'innerHTML'
			}
		]
	});

	const div = document.createElement('div');
	div.innerHTML = result.content;

	for (let i = 0; i < div.childElementCount; i++) {
		const element = div.children.item(i);
		const src = element?.getAttribute('data-src') || element?.getAttribute('src') || '';
		if (src) {
			imageURLs.push(src);
		}
	}

	return { imageURLs, referer };
}

async function extractionViaAPI(
	url: string,
	referer: string
): Promise<{ imageURLs: string[]; referer: string; host?: string }> {
	const imageURLs: string[] = [];
	switch (referer) {
		case 'https://mangadex.org': {
			const mangaDexImages = await mangaDex(url);
			imageURLs.push(...mangaDexImages);
			break;
		}

		default:
			throw Error('invalid url');
	}

	return { imageURLs, referer };
}

async function specialSiteExtraction(
	url: string,
	referer: string
): Promise<{ imageURLs: string[]; referer: string; host?: string; useCookie?: boolean }> {
	const imageURLs: string[] = [];
	let host: undefined | string = undefined;
	let useCookie: undefined | boolean = undefined;
	switch (referer) {
		case 'https://nhentai.net': {
			const result = await scraping<{ image: string; pages: string }>({
				url,
				querys: [
					{
						name: 'image',
						selector: '#thumbnail-container > div > div:nth-child(1) > a > img',
						target: 'attribute',
						attribute: 'data-src'
					},
					{
						name: 'pages',
						selector: '#tags > div:nth-child(8) > span > a > span',
						target: 'innerHTML'
					}
				]
			});

			const image = result.image
				.split('/')
				.map((image, index, array) => {
					if (index === array.length - 1) {
						const dotIndex = image.lastIndexOf('.');
						if (dotIndex !== -1) {
							return `{page}${image.substring(dotIndex)}`;
						}
					}
					return image;
				})
				.join('/');

			for (let i = 1; i <= Number(result.pages); i++) {
				imageURLs.push(image.replace('{page}', `${i}t`));
			}
			break;
		}

		case 'https://2nd.nekopost.net':
		case 'https://www.nekopost.net': {
			const cookieConfig = await getConfig('nekopost');
			const headers: Record<string, string> = {
				Cookie: cookieConfig?.value || '',
				'User-Agent': userAgent,
				Referer: 'https://www.nekopost.net/',
				Origin: 'https://www.nekopost.net'
			};

			const { images: imgs, page } = await scraping<{ images: string[]; page: string }>({
				url,
				headers,
				waitUntil: 'domcontentloaded',
				waitTime: 5000,
				isLazyLoad: true,
				heightSelector: 'body > div > div.min-h-screen',
				querys: [
					{
						name: 'images',
						selector: 'div.min-h-screen.w-full',
						target: 'children',
						children: {
							selector: 'img.active',
							target: 'attribute',
							attribute: 'src'
						}
					},
					{
						name: 'page',
						selector: 'div.min-h-screen.w-full > div.flex > .toggleTopMenu > div:nth-child(2)',
						target: 'innerHTML'
					}
				]
			});
			const images = imgs.filter((image) => image.trim());

			if (images.length === 0) {
				throw Error('image not found');
			} else if (!page) {
				throw Error('page not found');
			}

			const matches = /\/\s*(\d+)/.exec(page);
			if (!matches || matches.length < 2) {
				throw Error('invalid page');
			}
			const totalPages = Number(matches[1]);
			if (images.length < totalPages) {
				throw Error('incomplete images');
			}

			imageURLs.push(...images);
			host = 'www.osemocphoto.com';
			break;
		}

		case 'https://cats-translator.com': {
			const result = await scraping<{ images: string[] }>({
				url,
				querys: [
					{
						name: 'images',
						selector: '.reading-content',
						target: 'children',
						children: {
							target: 'innerHTML'
						}
					}
				]
			});

			const urls: string[] = [];
			for (const image of result.images) {
				const div = document.createElement('div');
				div.innerHTML = image;
				if (
					div.hasChildNodes() &&
					div.childElementCount >= 1 &&
					div.children.item(0)?.hasAttribute('data-src')
				) {
					urls.push(div.children.item(0)?.getAttribute('data-src') || '');
				}
			}

			imageURLs.push(...urls.filter((image) => image.trim()).map((image) => image.trim()));
			break;
		}

		case 'https://ok-doujinx.com': {
			const cookieConfig = await getConfig('ok-doujinx');
			const headers: Record<string, string> = {
				Cookie: cookieConfig?.value || '',
				'User-Agent': userAgent
			};

			const result = await scraping<{ images: string[] }>({
				url,
				headers,
				querys: [
					{
						name: 'images',
						selector: '.read-container > .reading-content',
						target: 'children',
						children: {
							selector: 'img',
							target: 'attribute',
							attribute: 'data-src'
						}
					}
				]
			});

			result.images = result.images.map((image) => image.replaceAll('\t', '').replaceAll('\n', ''));

			imageURLs.push(...result.images);
			useCookie = true;
			break;
		}

		case 'https://manghaha.com': {
			const result = await scraping<{ image: string }>({
				url,
				querys: [
					{
						name: 'image',
						selector: '.manga-image-all',
						target: 'innerHTML'
					}
				]
			});

			const div = document.createElement('div');
			div.innerHTML = result.image;
			for (let i = 0; i < div.childElementCount; i++) {
				const child = div.children.item(i);
				if (child && child.hasAttribute('src')) {
					imageURLs.push(referer + (child.getAttribute('src') || ''));
				}
			}
			break;
		}

		case 'https://visortmo.com': {
			const result = await scraping<{ images: string[] }>({
				url,
				querys: [
					{
						name: 'images',
						selector: '#main-container',
						target: 'children',
						children: {
							selector: 'img',
							target: 'attribute',
							attribute: 'data-src'
						}
					}
				]
			});

			imageURLs.push(...result.images);
			break;
		}

		case 'https://mangakakalot.com':
		case 'https://chapmanganato.to': {
			const result = await scraping<{ images: string[] }>({
				url,
				querys: [
					{
						name: 'images',
						selector: '.container-chapter-reader',
						target: 'children',
						children: {
							target: 'attribute',
							attribute: 'src'
						}
					}
				]
			});

			imageURLs.push(...result.images);
			break;
		}

		case 'https://afterwaaay.blogspot.com':
		case 'https://youweissman.blogspot.com': {
			const result = await scraping<{ images: string[] }>({
				url,
				querys: [
					{
						name: 'images',
						selector: '.entry-content',
						target: 'children',
						children: {
							selector: 'a',
							target: 'attribute',
							attribute: 'href'
						}
					}
				]
			});

			imageURLs.push(...result.images);
			break;
		}

		// case 'https://doujinx-h.com': {
		//     const result = await scraping<{ images: string[] }>({
		//         url,
		//         querys: [
		//             {
		//                 name: "images",
		//                 selector: ".reading-content",
		//                 target: "children",
		//                 children: {
		//                     selector: "img",
		//                     target: "attribute",
		//                     attribute: "data-src"
		//                 }
		//             },
		//         ],
		//     });

		//     imageURLs.push(...result.images.map(image => image.replaceAll('\t', '')));
		//     break;
		// }

		case 'https://catzaa.com':
		case 'https://manga-uptocats.com':
		case 'https://toonily.com': {
			const result = await scraping<{ images: string[] }>({
				url,
				querys: [
					{
						name: 'images',
						selector: '.reading-content',
						target: 'children',
						children: {
							selector: 'img',
							target: 'attribute',
							attribute: 'data-src'
						}
					}
				]
			});

			referer += '/';
			imageURLs.push(...result.images.map((image) => image.trim().replaceAll('\t', '')));
			break;
		}

		case 'https://pleasebehavemywife.online': {
			const result = await scraping<{ images: string[] }>({
				url,
				isLazyLoad: true,
				querys: [
					{
						name: 'images',
						selector: '#content',
						target: 'children',
						children: {
							selector: 'img',
							target: 'attribute',
							attribute: 'src'
						}
					}
				]
			});

			referer += '/';
			imageURLs.push(...result.images);
			break;
		}

		case 'https://harimanga.me': {
			const result = await scraping<{ images: string[] }>({
				url,
				querys: [
					{
						name: 'images',
						selector: '.reading-content',
						target: 'children',
						children: {
							selector: 'img',
							target: 'attribute',
							attribute: 'src'
						}
					}
				]
			});

			referer += '/';
			imageURLs.push(...result.images);
			break;
		}

		case 'https://xbato.com': {
			const result = await scraping<{ images: string[] }>({
				url,
				querys: [
					{
						name: 'images',
						selector: '#viewer',
						target: 'children',
						children: {
							selector: 'img',
							target: 'attribute',
							attribute: 'src'
						}
					}
				]
			});

			referer += '/';
			imageURLs.push(...result.images);
			break;
		}

		default:
			throw Error('unsupport domain');
	}

	return { imageURLs, referer, host, useCookie };
}

export const unscrapableSites: string[] = [
	// 'https://www.nekopost.net',
	// 'https://mangadex.org',
	'https://raw.senmanga.com',
	'https://www.facebook.com'
];

export async function scrapingDoujin(url: string): Promise<DoujinDetail> {
	const origin = new URL(url).origin;
	switch (origin) {
		case 'https://niyaniya.moe':
		case 'https://koharu.to':
		case 'https://nhentai.net': {
			const res = await scrapingViaAPI(url);
			if (!res) {
				throw Error('invalid link');
			}
			res.artists = res.artists.map((artist) => capitalize(artist, ' '));
			res.tags = res.tags.map((tag) => capitalize(tag, ' '));
			res.characters = res.characters.map((character) => capitalize(character, ' '));
			return res;
		}

		case 'https://miku-doujin.com': {
			const codes = url
				.replaceAll(origin, '')
				.split('/')
				.filter((code) => code);
			if (codes.length === 0 || codes.length > 2) {
				throw Error('invalid code');
			}

			const cookieConfig = await getConfig(DoujinSource.MikuDoujin);
			const headers: Record<string, string> = {
				Cookie: cookieConfig?.value || '',
				'User-Agent': userAgent
			};

			const queryImages = [
				{
					name: 'content',
					selector: '#manga-content',
					target: 'innerHTML'
				}
			];
			const queryBody = [
				{
					name: 'title',
					selector: '.card > .card-header > b',
					target: 'innerHTML'
				},
				{
					name: 'cover',
					selector: '.card > .card-body > .row > div > img',
					target: 'attribute',
					attribute: 'src'
				},
				{
					name: 'artists',
					selector: '.card > .card-body > .row > div:nth-child(2) > p:nth-child(4) > small > a',
					target: 'innerHTML'
				},
				{
					name: 'characters',
					selector: '.card-body.sr-card-body div:nth-child(7)',
					target: 'innerHTML'
				},
				{
					name: 'tags',
					selector: '.card-body.sr-card-body small:nth-child(12)',
					target: 'innerHTML'
				}
			];
			const queryBodyOldVersion = [
				{
					name: 'title',
					selector: '.card > .card-header > b',
					target: 'innerHTML'
				},
				{
					name: 'cover',
					selector: '.card > .card-body > .row > div > img',
					target: 'attribute',
					attribute: 'src'
				},
				{
					name: 'artists',
					selector: '.card > .card-body > .row > div:nth-child(2) > p:nth-child(4) > small > a',
					target: 'innerHTML'
				},
				{
					name: 'tags',
					selector: '.card-body.sr-card-body small:nth-child(9)',
					target: 'innerHTML'
				}
			];

			interface MikuContent {
				content: string;
				title: string;
				cover: string;
				artists: string;
				characters: string;
				tags: string;
			}

			let result!: MikuContent;
			if (codes.length === 1) {
				try {
					result = await scraping<MikuContent>({
						url,
						headers,
						querys: [...queryImages, ...queryBody]
					});
				} catch (error) {
					result = await scraping<MikuContent>({
						url,
						headers,
						querys: [...queryImages, ...queryBodyOldVersion]
					});
				}
			} else if (codes.length === 2) {
				let resultMain!: MikuContent;
				try {
					resultMain = await scraping<MikuContent>({
						url: `${origin}/${codes[0]}/`,
						headers,
						querys: queryBody
					});
				} catch (error) {
					resultMain = await scraping<MikuContent>({
						url: `${origin}/${codes[0]}/`,
						headers,
						querys: queryBodyOldVersion
					});
				}
				const resultContent = await scraping<MikuContent>({
					url,
					headers,
					buttonSelector: '#read-gate-btn',
					querys: queryImages
				});
				result = { ...resultMain, ...resultContent };
			}

			const div = document.createElement('div');
			div.innerHTML = result.content;

			// extract image content
			const imageURLs: string[] = [];
			for (let i = 0; i < div.childElementCount; i++) {
				const element = div.children.item(i);
				const src = element?.getAttribute('data-src') || element?.getAttribute('src') || '';
				if (src) {
					imageURLs.push(src);
				}
			}

			// extract tags
			const extractTags = (html: string): string[] => {
				const element = document.createElement('div');
				element.innerHTML = html;
				const tags = [...new Array(element.childElementCount)].map(
					(_, index) => element.children[index].children[0].innerHTML
				);
				if (!tags.length) {
					return ['Unknown'];
				}
				return tags;
			};

			if (imageURLs.length <= 1) {
				throw Error('invalid content');
			}

			return {
				artists: [result.artists || 'Unknown'].map((tag) => capitalize(tag, ' ')),
				characters: extractTags(result.characters).map((tag) => capitalize(tag, ' ')),
				tags: extractTags(result.tags).map((tag) => capitalize(tag, ' ')),
				link: url,
				code: codes.join('@'),
				source: DoujinSource.MikuDoujin,
				imageURLs,
				coverImageURL: result.cover,
				title: result.title.replaceAll(`<i class="fa fa-google"></i>`, '').trim()
			};
		}

		case 'https://neko-hentai.net': {
			const codes = url
				.replaceAll(origin, '')
				.split('/')
				.filter((code) => code);
			if (codes.length < 1 || codes.length > 2) {
				throw Error('invalid code');
			}

			const cookieConfig = await getConfig(DoujinSource.NekoHentai);
			const headers: Record<string, string> = {
				Cookie: cookieConfig?.value || '',
				'User-Agent': userAgent
			};

			const imageURLsQueries = [
				{
					name: 'imageURLs',
					selector: '#manga-content > div > div',
					target: 'children',
					children: {
						target: 'attribute',
						attribute: 'data-src'
					}
				}
			];
			const imageURLsOldVersionQueries = [
				{
					name: 'imageURLs',
					selector: '#manga-content > div > div',
					target: 'children',
					children: {
						target: 'attribute',
						attribute: 'src'
					}
				}
			];

			const bodyQueries = [
				{
					name: 'cover',
					selector: '.poppular > div > div.row.mt-4 > div.col-12.col-md-3 > img',
					target: 'attribute',
					attribute: 'src'
				},
				{
					name: 'title',
					selector: '.poppular > div > h1',
					target: 'innerHTML'
				},
				{
					name: 'artists',
					selector:
						'.poppular > div > div.row.mt-4 > div.col-12.col-md-9 > div:nth-child(3) > div.col-9',
					target: 'children',
					children: {
						target: 'innerHTML'
					}
				},
				{
					name: 'tags',
					selector:
						'.poppular > div > div.row.mt-4 > div.col-12.col-md-9 > div:nth-child(4) > div.col-9',
					target: 'children',
					children: {
						target: 'innerHTML'
					}
				}
			];

			interface NekoHentai {
				imageURLs: string[];
				cover: string;
				title: string;
				artists: string[];
				tags: string[];
			}

			let result!: NekoHentai;

			if (codes.length === 1) {
				result = await scraping<NekoHentai>({
					headers,
					url,
					querys: [...imageURLsQueries, ...bodyQueries]
				});
				if (result.imageURLs.length === 0) {
					result = await scraping<NekoHentai>({
						headers,
						url,
						querys: [...imageURLsOldVersionQueries, ...bodyQueries]
					});
				}
			} else {
				const resultMetadata = await scraping<NekoHentai>({
					headers,
					url: `${origin}/${codes[0]}/`,
					querys: bodyQueries
				});
				let resultImage = await scraping<NekoHentai>({
					headers,
					url,
					querys: imageURLsQueries
				});
				if (resultImage.imageURLs.length === 0) {
					resultImage = await scraping<NekoHentai>({
						headers,
						url,
						querys: imageURLsOldVersionQueries
					});
				}
				result = { ...resultMetadata, ...resultImage };
			}

			return {
				artists: result.artists,
				characters: ['Unknown'],
				tags: result.tags,
				link: url,
				code: codes.join('@'),
				source: DoujinSource.NekoHentai,
				imageURLs: result.imageURLs,
				coverImageURL: result.cover,
				title: result.title.replaceAll('<small></small>', '').trim()
			};
		}

		case 'https://cat300.net': {
			const codes = url
				.replaceAll(`${origin}/manga/`, '')
				.split('/')
				.filter((code) => code);
			if (codes.length !== 2) {
				throw Error('invalid code');
			}

			interface CatHentai {
				content: string[];
				title: string;
				cover: string;
				artists: string[];
				tags: string[];
			}

			const metadataResult = await scraping<CatHentai>({
				url: `${origin}/manga/${codes[0]}`,
				querys: [
					{
						name: 'cover',
						selector: '.summary_image > a > img',
						target: 'attribute',
						attribute: 'src'
					},
					{
						name: 'title',
						selector: '.post-title > h1',
						target: 'innerHTML'
					},
					{
						name: 'artists',
						selector: '.author-content',
						target: 'children',
						children: {
							target: 'innerHTML'
						}
					},
					{
						name: 'tags',
						selector: '.genres-content',
						target: 'children',
						children: {
							target: 'innerHTML'
						}
					}
				]
			});

			const contentResult = await scraping<CatHentai>({
				url,
				querys: [
					{
						name: 'content',
						selector: '.reading-content',
						target: 'children',
						children: {
							selector: 'img',
							target: 'attribute',
							attribute: 'src'
						}
					}
				]
			});

			return {
				artists: metadataResult.artists,
				characters: ['Unknown'],
				tags: metadataResult.tags,
				link: url,
				code: codes.map((code) => decodeURIComponent(code)).join('@'),
				source: DoujinSource.Cat300,
				imageURLs: contentResult.content.map((image) => image.replaceAll('\n', '').trim()),
				coverImageURL: metadataResult.cover,
				title: metadataResult.title.replaceAll('\n', '').trim()
			};
		}

		case 'https://hxhani.com': {
			const codes = url
				.replaceAll(origin, '')
				.split('/')
				.filter((code) => code);
			if (codes.length !== 1) {
				throw Error('invalid code');
			}

			interface HAniContent {
				title: string;
				cover: string;
				tags: string[];
				content: string[];
			}

			const result = await scraping<HAniContent>({
				url,
				querys: [
					{
						name: 'title',
						selector: '.card-body > div:nth-child(4) > a > u',
						target: 'innerHTML'
					},
					{
						name: 'tags',
						selector: '.card-body > .watch-detail',
						target: 'children',
						children: {
							target: 'innerHTML'
						}
					},
					{
						name: 'cover',
						selector: '#hdoujin > img',
						target: 'attribute',
						attribute: 'src'
					},
					{
						name: 'content',
						selector: '#hdoujin',
						target: 'children',
						children: {
							target: 'attribute',
							attribute: 'data-src'
						}
					}
				]
			});

			const artists: string[] = [];
			const matches = clawBracketsRegex.exec(result.title);
			if (matches && matches.length >= 2) {
				artists.push(matches[1]);
				result.title = result.title.replaceAll(matches[1] + ' ', '');
			} else {
				result.tags.forEach((tag) => {
					if (tag.startsWith('[')) {
						const matches = clawBracketsRegex.exec(tag);
						if (matches && matches.length >= 2) {
							const div = document.createElement('div');
							div.innerHTML = matches[1];
							const artist = div.querySelector('a')?.innerHTML;
							if (artist) {
								artists.push(artist);
							}
						}
					}
				});
			}
			if (artists.length === 0) {
				artists.push('Unknown');
			}
			if (!result.cover) {
				result.cover = result.content[0];
			} else {
				result.content = [result.cover, ...result.content];
			}

			return {
				artists,
				characters: ['Unknown'],
				tags: result.tags.filter((tag) => !tag.startsWith('[')).map((tag) => tag.trim()),
				link: url,
				code: codes[0],
				source: DoujinSource.HAni,
				imageURLs: result.content,
				coverImageURL: result.cover,
				title: result.title.trim()
			};
		}

		case 'https://doujin-th.com': {
			const code = url.replaceAll(`${origin}/forum/index.php?topic=`, '');
			if (isNaN(Number(code))) {
				throw Error('invalid code');
			}

			interface HAniContent {
				title: string;
				subTitle: string;
				tags: string[];
				images: string[];
			}

			const result = await scraping<HAniContent>({
				url,
				querys: [
					{
						name: 'title',
						selector: '.panel-heading .panel-title',
						target: 'innerHTML'
					},
					{
						name: 'subTitle',
						selector: '.panel-body .panel-title',
						target: 'innerHTML'
					},
					{
						name: 'tags',
						selector: '.panel-body',
						target: 'children',
						children: {
							selector: 'a',
							target: 'innerHTML'
						}
					},
					{
						name: 'images',
						selector: 'body > div:nth-child(6) > div:nth-child(2) > div.col-xs-12.col-md-8',
						target: 'children',
						children: {
							selector: 'img',
							target: 'attribute',
							attribute: 'src'
						}
					}
				]
			});

			const artists: string[] = [];
			const matches = bracketsRegex.exec(result.subTitle);
			if (matches && matches.length >= 2) {
				artists.push(matches[1]);
			} else {
				const matches = clawBracketsRegex.exec(result.subTitle);
				if (matches && matches.length >= 2) {
					artists.push(matches[1]);
				}
			}
			if (artists.length === 0) {
				artists.push('Unknown');
			}

			return {
				artists,
				characters: ['Unknown'],
				tags: result.tags,
				link: url,
				code,
				source: DoujinSource.DoujinTH,
				imageURLs: result.images,
				coverImageURL: result.images[0],
				title: result.title.trim()
			};
		}

		case 'https://ok-doujinx.com': {
			const codes = url
				.replaceAll(`${origin}/manga/`, '')
				.split('/')
				.filter((code) => code);
			if (codes.length !== 2) {
				throw Error('invalid code');
			}

			interface OKDoujinXContent {
				title: string;
				artists: string[];
				tags: string[];
				coverImageURL: string;
				images: string[];
			}

			const cookieConfig = await getConfig('ok-doujinx');
			const headers: Record<string, string> = {
				Cookie: cookieConfig?.value || '',
				'User-Agent': userAgent
			};

			const resultImage = await scraping<OKDoujinXContent>({
				url,
				headers,
				querys: [
					{
						name: 'images',
						selector: '.read-container > .reading-content',
						target: 'children',
						children: {
							selector: 'img',
							target: 'attribute',
							attribute: 'data-src'
						}
					}
				]
			});

			const resultContent = await scraping<OKDoujinXContent>({
				url: `${origin}/manga/${codes[0]}/`,
				headers,
				querys: [
					{
						name: 'coverImageURL',
						selector: '.summary_image > a > img',
						target: 'attribute',
						attribute: 'data-src'
					},
					{
						name: 'title',
						selector: '.post-title > h1',
						target: 'innerHTML'
					},
					{
						name: 'artists',
						selector: '.author-content',
						target: 'children',
						children: {
							target: 'innerHTML'
						}
					},
					{
						name: 'tags',
						selector: '.genres-content',
						target: 'children',
						children: {
							target: 'innerHTML'
						}
					}
				]
			});

			return {
				artists: resultContent.artists,
				characters: ['Unknown'],
				tags: resultContent.artists,
				link: url,
				code: codes.map((code) => decodeURIComponent(code)).join('@'),
				source: DoujinSource.OKDoujinX,
				imageURLs: resultImage.images.map((image) =>
					image.replaceAll('\t', '').replaceAll('\n', '')
				),
				coverImageURL: resultContent.coverImageURL,
				title: resultContent.title.trim()
			};
		}

		case 'https://doujints.com': {
			const codes = url
				.replaceAll(origin, '')
				.split('/')
				.filter((code) => code);
			if (codes.length !== 1) {
				throw Error('invalid code');
			}

			interface DoujinTSContent {
				images: string[];
				tags: string[];
				title: string;
			}

			const result = await scraping<DoujinTSContent>({
				url,
				querys: [
					{
						name: 'images',
						selector:
							'body > div.container > div > div.col-xs-12.col-md-8.mx-auto.d-block.container-fluid.no-padding',
						target: 'children',
						children: {
							target: 'attribute',
							attribute: 'data-src'
						}
					},
					{
						name: 'tags',
						selector: '.card-body > .well',
						target: 'children',
						children: {
							target: 'attribute',
							attribute: 'href'
						}
					},
					{
						name: 'title',
						xpath: '/html/body/div[3]/div/div[1]/div[2]/div/text()[1]',
						target: 'textContent'
					}
				]
			});

			const artists: string[] = [];
			const matches = bracketsRegex.exec(result.title);
			if (matches && matches.length >= 2) {
				artists.push(matches[1].split(',')[0].trim());
			}
			if (artists.length === 0) {
				artists.push('Unknown');
			}

			// use data-src for lazy load
			result.images = result.images.map((image) => image.replaceAll('i0.wp.com/', ''));

			const clawMatches = clawBracketsRegex.exec(result.title);
			if (clawMatches && clawMatches.length >= 2) {
				result.title = result.title.replaceAll(`[${clawMatches[1]}]`, '');
			}

			return {
				artists,
				characters: ['Unknown'],
				tags: result.tags
					.filter((tag) => tag !== '/tags')
					.map((tag) => tag.replaceAll(`${origin}/tag/`, '').split('/')[0]),
				link: url,
				code: codes[0],
				source: DoujinSource.DoujinTS,
				imageURLs: result.images,
				coverImageURL: result.images[0],
				title: result.title.replaceAll('\n', '').trim()
			};
		}

		case 'https://nhentai.website': {
			const code = url.replaceAll(origin + '/g/', '').replaceAll('#_', '');
			if (!Number(code)) {
				throw Error('invalid code');
			}

			const { cover, title, images, list } = await scraping<{
				cover: string;
				title: string;
				images: string[];
				list: string[];
			}>({
				url,
				querys: [
					{
						name: 'cover',
						selector: '#bigcontainer > #cover > a > img',
						target: 'attribute',
						attribute: 'data-src'
					},
					{
						name: 'title',
						selector: '#info > h1',
						target: 'innerHTML'
					},
					{
						name: 'images',
						selector: '#thumbnail-container',
						target: 'children',
						children: {
							selector: 'img',
							target: 'attribute',
							attribute: 'data-src'
						}
					},
					{
						name: 'list',
						selector: '#tags',
						target: 'children',
						children: {
							target: 'innerHTML'
						}
					}
				]
			});

			const info = (label: string, index: number) => ({
				name: label,
				selector: `.tag-container:nth-child(${index + 1}) > .tags`,
				target: 'children',
				children: {
					selector: 'a > .name',
					target: 'innerHTML'
				}
			});

			const listMapping: Map<string> = {
				artists: 'Artists',
				tags: 'Tags',
				characters: 'Characters'
			};

			const querys: ScrapingQuery[] = [];
			const fieldNames = list.map((item) => item.replaceAll(' ', '').split('\n')[1]);
			for (const [key, label] of Object.entries(listMapping)) {
				if (fieldNames.includes(label)) {
					querys.push(info(key, fieldNames.indexOf(label)));
				}
			}

			const { artists, tags, characters } = await scraping<{
				artists: string[];
				tags: string[];
				characters: string[];
			}>({
				url,
				querys
			});

			return {
				artists: (artists || ['Unknown']).map((artist) => capitalize(artist, ' ')),
				characters: (characters || ['Unknown']).map((character) => capitalize(character, ' ')),
				tags: (tags || ['Unknown']).map((tag) => capitalize(tag, ' ')),
				link: url,
				code,
				source: DoujinSource.NHentaiWebsite,
				imageURLs: images.map((image) => image.replaceAll('t.', '.')),
				coverImageURL: cover,
				title: title.trim()
			};
		}

		case 'https://nhentai.xxx': {
			const code = url.replaceAll(origin + '/g/', '').replaceAll('/', '');
			if (!Number(code)) {
				throw Error('invalid code');
			}

			const { cover, title, images, list } = await scraping<{
				cover: string;
				title: string;
				images: string[];
				list: string;
			}>({
				url,
				querys: [
					{
						name: 'cover',
						selector: '.cover > a > img',
						target: 'attribute',
						attribute: 'data-src'
					},
					{
						name: 'title',
						selector: '.info > h1',
						target: 'innerHTML'
					},
					{
						name: 'images',
						selector: '#thumbs_append',
						target: 'children',
						children: {
							selector: 'img',
							target: 'attribute',
							attribute: 'data-src'
						}
					},
					{
						name: 'list',
						selector: '.info ul',
						target: 'innerHTML'
					}
				]
			});

			const info = (label: string, index: number) => ({
				name: label,
				selector: `.info > ul > li:nth-child(${index + 1})`,
				target: 'children',
				children: {
					selector: 'a > .tag_name',
					target: 'innerHTML'
				}
			});

			const listMapping: Map<string> = {
				artists: 'Artists',
				tags: 'Tags',
				characters: 'Characters'
			};

			const querys: ScrapingQuery[] = [];
			const div = document.createElement('div');
			div.innerHTML = list.replaceAll('\n', '').replaceAll('\t', '');
			for (let i = 0; i < div.children.length; i++) {
				const element = div.children.item(i);
				if (element) {
					const tag = element.querySelector('.text')?.innerHTML;
					for (const [key, label] of Object.entries(listMapping)) {
						if (tag?.includes(label)) {
							querys.push(info(key, tag.indexOf(label)));
						}
					}
				}
			}

			const { artists, tags, characters } = await scraping<{
				artists: string[];
				tags: string[];
				characters: string[];
			}>({
				url,
				querys
			});

			return {
				artists: (artists || ['Unknown']).map((artist) => capitalize(artist, ' ')),
				characters: (characters || ['Unknown']).map((character) => capitalize(character, ' ')),
				tags: (tags || ['Unknown']).map((tag) => capitalize(tag, ' ')),
				link: url,
				code,
				source: DoujinSource.NHentaiXXX,
				imageURLs: images.map((image) => image.replaceAll('t.', '.')),
				coverImageURL: cover,
				title: title.trim()
			};
		}

		case 'https://nhentai.to': {
			const code = url.replaceAll(origin + '/g/', '').replaceAll('/', '');
			if (!Number(code)) {
				throw Error('invalid code');
			}

			const cookieConfig = await getConfig('nhentai.to');
			const headers: Record<string, string> = {
				Cookie: cookieConfig?.value || '',
				'User-Agent': userAgent
			};

			const { cover, title, images, list } = await scraping<{
				cover: string;
				title: string;
				images: string[];
				list: string[];
			}>({
				url,
				headers,
				querys: [
					{
						name: 'cover',
						selector: '#bigcontainer > #cover > a > img',
						target: 'attribute',
						attribute: 'src'
					},
					{
						name: 'title',
						selector: '#info > h1',
						target: 'innerHTML'
					},
					{
						name: 'images',
						selector: '#thumbnail-container',
						target: 'children',
						children: {
							selector: 'img',
							target: 'attribute',
							attribute: 'data-src'
						}
					},
					{
						name: 'list',
						selector: '#tags',
						target: 'children',
						children: {
							target: 'innerHTML'
						}
					}
				]
			});

			const info = (label: string, index: number) => ({
				name: label,
				selector: `.tag-container:nth-child(${index + 1}) > .tags`,
				target: 'children',
				children: {
					selector: 'a > .name',
					target: 'innerHTML'
				}
			});

			const listMapping: Map<string> = {
				artists: 'Artists',
				tags: 'Tags',
				characters: 'Characters'
			};

			const querys: ScrapingQuery[] = [];
			const fieldNames = list.map((item) => item.replaceAll(' ', '').split('\n')[1]);
			for (const [key, label] of Object.entries(listMapping)) {
				if (fieldNames.includes(label)) {
					querys.push(info(key, fieldNames.indexOf(label)));
				}
			}

			const { artists, tags, characters } = await scraping<{
				artists: string[];
				tags: string[];
				characters: string[];
			}>({
				url,
				headers,
				querys
			});

			return {
				artists: (artists || ['Unknown']).map((artist) => capitalize(artist, ' ')),
				characters: (characters || ['Unknown']).map((character) => capitalize(character, ' ')),
				tags: (tags || ['Unknown']).map((tag) => capitalize(tag, ' ')),
				link: url,
				code,
				source: DoujinSource.NHentaiTO,
				imageURLs: images.map((image) => image.replaceAll('t.', '.')),
				coverImageURL: cover,
				title: title.trim()
			};
		}

		case 'https://ecchi-doujin.com': {
			const codes = url
				.replaceAll(origin, '')
				.split('/')
				.filter((code) => code);
			if (codes.length !== 1) {
				throw Error('invalid code');
			}

			let code = codes[0];
			const texts = code.split('-');
			let chapter = 1;
			if (Number(texts[texts.length - 1])) {
				chapter = Number(texts[texts.length - 1]);
				code = texts.splice(0, texts.length - 1).join('-');
			}

			const { title, main, images } = await scraping<{
				title: string;
				main: string;
				images: string[];
			}>({
				url,
				querys: [
					{
						name: 'title',
						selector: '.entry-title',
						target: 'innerHTML'
					},
					{
						name: 'images',
						selector: '#readerarea',
						target: 'children',
						children: {
							target: 'attribute',
							attribute: 'src'
						}
					},
					{
						name: 'main',
						selector: '.postarea > article > .headpost > div > a',
						target: 'attribute',
						attribute: 'href'
					}
				]
			});

			const { tags, cover } = await scraping<{ tags: string[]; cover: string }>({
				url: main,
				querys: [
					{
						name: 'tags',
						selector: '.seriestugenre',
						target: 'children',
						children: {
							target: 'innerHTML'
						}
					},
					{
						name: 'cover',
						selector: '.thumb > img',
						target: 'attribute',
						attribute: 'src'
					}
				]
			});

			let artists = ['Unknown'];
			const clawMatches = clawBracketsRegex.exec(title);
			if (clawMatches && clawMatches.length >= 2) {
				artists = [clawMatches[1]];
			}

			return {
				artists,
				characters: ['Unknown'],
				tags: (tags || ['Unknown']).map((tag) => capitalize(tag, ' ')),
				link: url,
				code: `${decodeURI(code)}@${chapter}`,
				source: DoujinSource.EcchiDoujin,
				imageURLs: images,
				coverImageURL: cover,
				title: title.trim()
			};
		}

		case 'https://hentaithai.com': {
			const codes = url
				.replaceAll(origin + '/', '')
				.split('/')
				.filter((code) => code);
			if (codes.length !== 1) {
				throw Error('invalid code');
			}
			const code = codes[0];

			const { title, images } = await scraping<{
				title: string;
				images: string[];
			}>({
				url,
				querys: [
					{
						name: 'title',
						selector: '.card-header > h1',
						target: 'innerHTML'
					},
					{
						name: 'images',
						selector: '#part-image',
						target: 'children',
						children: {
							selector: 'img',
							target: 'attribute',
							attribute: 'src'
						}
					}
				]
			});

			let artists = ['Unknown'];
			const clawMatches = clawBracketsRegex.exec(title);
			if (clawMatches && clawMatches.length >= 2) {
				artists = [clawMatches[1]];
			}

			return {
				artists,
				characters: ['Unknown'],
				tags: ['Unknown'],
				link: url,
				code,
				source: DoujinSource.HentaiThai,
				imageURLs: images,
				coverImageURL: images[0],
				title: title.trim()
			};
		}

		case 'https://netoruhentai.com': {
			const codes = url
				.replaceAll(origin + '/', '')
				.split('/')
				.filter((code) => code);
			if (codes.length !== 1) {
				throw Error('invalid code');
			}
			const code = codes[0];

			const { title, gallery, tags, images } = await scraping<{
				title: string;
				gallery: string;
				tags: string[];
				images: string[];
			}>({
				url,
				querys: [
					{
						name: 'title',
						selector: '#info > h1 > a > span',
						target: 'innerHTML'
					},
					{
						name: 'gallery',
						selector: '#gallery_id',
						target: 'innerHTML'
					},
					{
						name: 'tags',
						selector: '#tags > div:nth-child(2) > span',
						target: 'children',
						children: {
							selector: 'span',
							target: 'innerHTML'
						}
					},
					{
						name: 'images',
						selector: '#image-container',
						target: 'children',
						children: {
							target: 'attribute',
							attribute: 'data-src'
						}
					}
				]
			});

			let artists: string[] = ['Unknown'];
			const matches = clawBracketsRegex.exec(gallery);
			if (matches && matches.length >= 2) {
				artists = [capitalize(matches[1], ' ')];
			}

			return {
				artists,
				characters: ['Unknown'],
				tags: tags.map((tag) => capitalize(tag, ' ')),
				link: url,
				code,
				source: DoujinSource.NetoruHentai,
				imageURLs: images,
				coverImageURL: images[0],
				title: title.trim()
			};
		}

		case 'https://imhentai.xxx': {
			const codes = url
				.replace('https://imhentai.xxx/gallery/', '')
				.split('/')
				.filter((code) => code);
			if (codes.length !== 1) {
				throw Error('invalid code');
			}
			const code = codes[0];

			const { title, labels, cover, images } = await scraping<{
				title: string;
				cover: string;
				labels: string[];
				images: string[];
			}>({
				url,
				buttonSelector: '#load_all',
				querys: [
					{
						name: 'title',
						selector: '.right_details > h1',
						target: 'innerHTML'
					},
					{
						name: 'cover',
						selector: '.left_cover > a > img',
						target: 'attribute',
						attribute: 'data-src'
					},
					{
						name: 'labels',
						selector: '.galleries_info',
						target: 'children',
						children: {
							selector: 'span',
							target: 'innerHTML'
						}
					},
					{
						name: 'images',
						selector: '#append_thumbs',
						target: 'children',
						children: {
							selector: 'img',
							target: 'attribute',
							attribute: 'data-src'
						}
					}
				]
			});

			const keyMapping: Record<string, string> = {
				['Artists:']: 'artists',
				['Tags:']: 'tags'
			};

			let tags = ['Unknown'];
			let artists = ['Unknown'];
			const elements: ScrapingQuery[] = [];
			for (let i = 0; i < labels.length; i++) {
				const label = labels[i];
				const key = keyMapping[label];
				if (key) {
					elements.push({
						name: key,
						selector: `.galleries_info li:nth-child(${i + 1})`,
						target: 'children',
						children: {
							target: 'innerHTML'
						}
					});
				}
			}
			if (elements.length > 0) {
				const result = await scraping<{ tags: string[]; artists: string[] }>({
					url,
					querys: elements
				});
				if (result.tags.length > 0) {
					tags = result.tags;
				}
				if (result.artists.length > 0) {
					artists = result.artists;
				}
			}

			return {
				artists: artists
					.filter((artist) => !artist.includes(':'))
					.map((artist) => capitalize(artist.replace(/<[^>]*>.*?<\/[^>]*>/g, '').trim(), ' ')),
				characters: ['Unknown'],
				tags: tags
					.filter((tag) => !tag.includes(':'))
					.map((tag) => capitalize(tag.replace(/<[^>]*>.*?<\/[^>]*>/g, '').trim(), ' ')),
				link: url,
				code,
				source: DoujinSource.ImHentai,
				imageURLs: images.map((image) => image.replaceAll('t.', '.')),
				coverImageURL: cover,
				title: title.trim()
			};
		}
	}
	throw Error('invalid link');
}

export async function scrapingHentai(url: string): Promise<HentaiDetail> {
	const origin = new URL(url).origin;
	switch (origin) {
		case 'https://www.alpha-hen.com': {
			interface AlphaHenContent {
				coverImageURL: string;
				title: string;
				description: string;
				categories: string[];
				status: string;
				studio: string;
			}

			const query = [
				{
					name: 'title',
					selector: '.entry-post-detail > h1',
					target: 'innerHTML'
				},
				{
					name: 'description',
					selector: '.entry-post-detail > div > div:nth-child(1) > div > p',
					target: 'innerHTML'
				},
				{
					name: 'categories',
					selector: '.ez-entry-catgory > span.ez-e-t-second',
					target: 'children',
					children: {
						target: 'innerHTML'
					}
				},
				{
					name: 'status',
					selector: '.ez-entry-meta > a:nth-child(5) > span',
					target: 'innerHTML'
				},
				{
					name: 'studio',
					selector: '.ez-entry-catgory > div > a:nth-child(1)',
					target: 'innerHTML'
				}
			];

			let result!: AlphaHenContent;
			try {
				result = await scraping<AlphaHenContent>({
					url,
					querys: [
						{
							name: 'coverImageURL',
							selector: '.post-thumnail > picture > img',
							target: 'attribute',
							attribute: 'src'
						},
						...query
					]
				});
			} catch (error) {
				result = await scraping<AlphaHenContent>({
					url,
					querys: [
						{
							name: 'coverImageURL',
							selector: '.post-thumnail > img',
							target: 'attribute',
							attribute: 'src'
						},
						...query
					]
				});
			}

			if (['ซับไทย'].includes(result.studio)) {
				result.studio = 'Unknown';
			}

			return {
				...result,
				status: result.status === 'ยังไม่จบ' ? HentaiStatus.OnGoing : HentaiStatus.Completed,
				link: url
			};
		}

		default:
			throw Error('unsupported origin');
	}
}

export async function scrapingJAV(url: string): Promise<JAV> {
	const origin = new URL(url).origin;
	switch (origin) {
		case 'https://missav123.com':
		case 'https://missav.ws':
		case 'https://missav.com': {
			const headers: Record<string, string> = {
				'User-Agent': userAgent
			};

			const { cover, title, list } = await scraping<{
				cover: string;
				title: string;
				list: string[];
			}>({
				url,
				headers,
				querys: [
					{
						name: 'cover',
						selector: '.plyr__poster',
						target: 'attribute',
						attribute: 'style'
					},
					{
						name: 'title',
						selector: '.order-first > div > h1',
						target: 'innerHTML'
					},
					{
						name: 'list',
						selector:
							'.order-first > div > div:nth-child(2) > div:nth-child(1) > div > div.space-y-2:has(span)',
						target: 'children',
						children: {
							selector: 'span',
							target: 'innerHTML'
						}
					}
				]
			});

			const info = (label: string, index: number) => ({
				name: label,
				selector: `.order-first > div > div:nth-child(2) > div:nth-child(1) > div > div.space-y-2:has(span) > div:nth-child(${index + 1})`,
				target: 'children',
				children: {
					target: 'innerHTML'
				}
			});

			const listMapping: Map<string> = {
				codes: 'Code:',
				genres: 'Genre:',
				originalTitles: 'Title:',
				actresses: 'Actress:'
			};

			const querys: ScrapingQuery[] = [];
			for (const [key, label] of Object.entries(listMapping)) {
				if (list.includes(label)) {
					querys.push(info(key, list.indexOf(label)));
				}
			}

			const { genres, codes, actresses } = await scraping<{
				genres: string[];
				codes: string[];
				originalTitles: string[];
				actresses: string[];
			}>({
				url,
				headers,
				querys
			});

			const jav: JAV = {
				code: codes[1],
				coverImageURL: cover
					.replaceAll('background-image: ', '')
					.substring(5, cover.length - 'background-image: '.length - 3),
				actresses: actresses?.length ? actresses.splice(1) : ['Unknown'],
				genres: genres?.length ? genres.splice(1) : ['Unknown'],
				link: url,
				title
			};

			return jav;
		}

		default:
			throw Error('invalid origin');
	}
}

export async function scrapingNovel(url: string): Promise<{
	content: string;
	files: File[];
}> {
	url = url.trim();
	const origin = new URL(url).origin;
	const filePlaceholder = '<< parameters.file_id >>';
	const files: File[] = [];
	let content = '';

	switch (origin) {
		case 'https://2nd.nekopost.net':
		case 'https://www.nekopost.net': {
			const cookieConfig = await getConfig('nekopost');
			const headers: Record<string, string> = {
				Cookie: cookieConfig?.value || '',
				'User-Agent': userAgent,
				Referer: 'https://www.nekopost.net/',
				Origin: 'https://www.nekopost.net'
			};

			let { htmlContent } = await scraping<{ htmlContent: string }>({
				url,
				headers,
				waitUntil: 'networkidle2',
				isLazyLoad: true,
				heightSelector: 'div.min-h-screen.w-full',
				querys: [
					{
						name: 'htmlContent',
						selector: '.novel-content',
						target: 'innerHTML'
					}
				]
			});

			if (!htmlContent) {
				throw Error('content not found');
			}

			const div = document.createElement('div');
			div.innerHTML = htmlContent;
			const items = div.querySelectorAll('img');
			for (let i = 0; i < items.length; i++) {
				const item = items.item(i);
				const imageURL = item.getAttribute('src');
				if (imageURL) {
					const { data, mimeType } = await scrapingFile({ fileURL: imageURL, fetchFromURL: url });
					files.push(new File([data], imageURL, { type: mimeType }));
					htmlContent = htmlContent.replaceAll(imageURL, filePlaceholder);
				}
			}
			content = htmlContent;
			break;
		}

		default:
			throw Error(`unsupport domain ${origin}`);
	}

	return {
		content,
		files
	};
}
